// src/features/map/MapAttribution.jsx
import React, { useEffect, useState } from "react"

// Basemap kommt aus benchmap (GeoServer-intern, keine Fremd-Attribution) —
// es bleibt Leaflet plus optional OpenSeaMap.
const LEAFLET_LINK =
  '<a href="https://leafletjs.com/" target="_blank" rel="noopener noreferrer">Leaflet</a>'
const OPENSEA_LINK =
  '&copy; <a href="https://www.openseamap.org/index.php?id=imprint&L=1" target="_blank" rel="noopener noreferrer">OpenSeaMap</a>'

export default function MapAttribution({ map, show }) {
  const [openSeaActive, setOpenSeaActive] = useState(false)

  useEffect(() => {
    if (!map) return

    // Der Preset bietet kein attributionControl=false; der Tracker rendert seine eigene
    map.attributionControl?.remove()

    const handleOverlay = (e) => {
      if (e.name === "OpenSeaMap") {
        setOpenSeaActive(e.type === "overlayadd")
      }
    }

    map.on("overlayadd overlayremove", handleOverlay)
    return () => {
      map.off("overlayadd overlayremove", handleOverlay)
    }
  }, [map])

  if (!show) return null

  const text = openSeaActive
    ? `${LEAFLET_LINK} | ${OPENSEA_LINK}`
    : LEAFLET_LINK

  return (
    <>
      <style>
        {`
          .map-attribution a {
            text-decoration: none !important;
          }
        `}
      </style>
      <div
        className="map-attribution"
        style={{
          position: "fixed",
          right: 0,
          bottom: 0,
          zIndex: 1099,
          backgroundColor: "rgba(255,255,255,0.8)",
          padding: "2px 6px",
          fontSize: "12px",
          pointerEvents: "auto",
        }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </>
  )
}
